<div class="dashboard-filter-main-container">
    <div class="dashboard-filter-form-container">
        <div class="dashboard-visualization-level-wrapper">
            <div class="header">
                <div class="filter-icon">
                    <div class="funnel"></div>
                </div>
                <span>{{'db_filter.visualisation_header' | translate}}</span>
            </div>
            <div class="visualization-capture">
                <div class="radio-wrapper">
                    <mat-radio-group [(ngModel)]="selectedDBvisualizationLevel"
                        (change)="changeVisualizationLevel()">
                        <mat-radio-button class="visualization-radio-button fw {{visualization?.code}}"
                            *ngFor="let visualization of visualizationLevelList"
                            [disabled]="visualization?.level !=3"
                            [value]="visualization"
                            title="{{visualization?.translateCode | translate}}">
                            {{visualization?.translateCode | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="visualization-wrapper">
                    <mat-form-field *ngIf="selectedDBvisualizationLevel?.level>=1"
                        class="visualization-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_cluster' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="cluster"
                                type="text"
                                [matAutocomplete]="clusterAutoComplete"
                                [(ngModel)]="filteredData.cluster.searchText"
                                (ngModelChange)="applyFilter($event, 'cluster')">
                        </md-input-container>

                        <mat-autocomplete #clusterAutoComplete="matAutocomplete"
                            [displayWith]="clusterValueMapper">
                            <mat-option class="line-visualization"
                                *ngFor="let item of filteredData.cluster.list"
                                [value]="item"
                                title="{{item?.name}}">
                                {{item?.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field *ngIf="selectedDBvisualizationLevel?.level>=2"
                        class="visualization-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_factory' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="factory"
                                type="text"
                                [matAutocomplete]="factoryAutoComplete"
                                [(ngModel)]="filteredData.factory.searchText"
                                (ngModelChange)="applyFilter($event, 'factory')"
                                [disabled]="!selectedVisualizationValues.cluster">
                        </md-input-container>

                        <mat-autocomplete #factoryAutoComplete="matAutocomplete"
                            [displayWith]="factoryValueMapper">
                            <mat-option class="line-visualization"
                                *ngFor="let item of filteredData.factory.list"
                                [value]="item"
                                title="{{item?.name}}">
                                {{item?.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field *ngIf="selectedDBvisualizationLevel?.level>=3"
                        class="visualization-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_line' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="line"
                                type="text"
                                [matAutocomplete]="lineAutoComplete"
                                [(ngModel)]="filteredData.line.searchText"
                                (ngModelChange)="applyFilter($event, 'line')"
                                [disabled]="!selectedVisualizationValues.factory">
                        </md-input-container>

                        <mat-autocomplete #lineAutoComplete="matAutocomplete"
                            [displayWith]="lineValueMapper">
                            <mat-option class="line-visualization"
                                *ngFor="let item of filteredData.line.list"
                                [value]="item"
                                title="{{item?.name}}">
                                {{item?.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="dashboard-detail-level-wrapper"
            [ngClass]="{'disabled':!selectedVisualizationValues.line}">
            <div class="header">
                <div class="filter-icon">
                    <div class="funnel"></div>
                </div>
                <span>{{'db_filter.detail_header' | translate}}</span>
            </div>
            <div class="details-capture">
                <div class="radio-wrapper">
                    <mat-radio-group [(ngModel)]="selectedDBDetailLevel"
                        (change)="changeDetailLevel()">
                        <mat-radio-button class="detail-radio-button fw {{detail?.code}}"
                            *ngFor="let detail of detailLevelList"
                            [value]="detail"
                            [disabled]="!selectedVisualizationValues.line"
                            title="{{detail?.translateCode | translate}}">
                            {{detail?.translateCode | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="dd-wrapper">
                    <mat-form-field *ngIf="selectedDBDetailLevel?.level>=1"
                        class="detail-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_big_cat' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="bigCat"
                                type="text"
                                [matAutocomplete]="bigCatAutoComplete"
                                [(ngModel)]="filteredData.bigCat.searchText"
                                (ngModelChange)="applyFilter($event, 'bigCat')">
                        </md-input-container>

                        <mat-autocomplete #bigCatAutoComplete="matAutocomplete"
                            [displayWith]="bigCatValueMapper">
                            <mat-option class="line-detail"
                                *ngFor="let item of filteredData.bigCat.list"
                                [value]="item"
                                title="{{item?.value}}">
                                {{item?.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field *ngIf="selectedDBDetailLevel?.level>=2"
                        class="detail-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_category' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="category"
                                type="text"
                                [matAutocomplete]="categoryAutoComplete"
                                [(ngModel)]="filteredData.category.searchText"
                                (ngModelChange)="applyFilter($event, 'category')"
                                [disabled]="!selectedDetailvalues.bigCat">
                        </md-input-container>

                        <mat-autocomplete #categoryAutoComplete="matAutocomplete"
                            [displayWith]="categoryValueMapper">
                            <mat-option class="line-detail"
                                *ngFor="let item of filteredData.category.list"
                                [value]="item"
                                title="{{item?.value}}">
                                {{item?.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field *ngIf="selectedDBDetailLevel?.level>=3"
                        class="detail-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_sub_cat' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                type="text"
                                class="subCat"
                                [matAutocomplete]="subCatAutoComplete"
                                [(ngModel)]="filteredData.subCat.searchText"
                                (ngModelChange)="applyFilter($event, 'subCat')"
                                [disabled]="!selectedDetailvalues.category">
                        </md-input-container>

                        <mat-autocomplete #subCatAutoComplete="matAutocomplete"
                            [displayWith]="subCatValueMapper">
                            <mat-option class="line-detail"
                                *ngFor="let item of filteredData.subCat.list"
                                [value]="item"
                                title="{{item?.value}}">
                                {{item?.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field *ngIf="selectedDBDetailLevel?.level>=4"
                        class="detail-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_brand' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="brand"
                                type="text"
                                [matAutocomplete]="brandAutoComplete"
                                [(ngModel)]="filteredData.brand.searchText"
                                (ngModelChange)="applyFilter($event, 'brand')"
                                [disabled]="!selectedDetailvalues.subCat">
                        </md-input-container>

                        <mat-autocomplete #brandAutoComplete="matAutocomplete"
                            [displayWith]="brandValueMapper">
                            <mat-option class="line-detail"
                                *ngFor="let item of filteredData.brand.list"
                                [value]="item"
                                title="{{item?.value}}">
                                {{item?.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field *ngIf="selectedDBDetailLevel?.level>=5"
                        class="detail-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_product' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="product"
                                type="text"
                                [matAutocomplete]="productAutoComplete"
                                [(ngModel)]="filteredData.product.searchText"
                                (ngModelChange)="applyFilter($event, 'product')"
                                [disabled]="!selectedDetailvalues.brand">
                        </md-input-container>

                        <mat-autocomplete #productAutoComplete="matAutocomplete"
                            [displayWith]="productValueMapper">
                            <mat-option class="line-detail"
                                *ngFor="let item of filteredData.product.list"
                                [value]="item"
                                title="{{item?.value}}">
                                {{item?.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field *ngIf="selectedDBDetailLevel?.level===6"
                        class="detail-select-container"
                        appearance="outline">
                        <mat-label>{{'filter_dropdowns.sel_bom_component' | translate}}</mat-label>
                        <md-input-container>
                            <input matInput
                                class="bom"
                                type="text"
                                [matAutocomplete]="bomAutoComplete"
                                [(ngModel)]="filteredData.bom.searchText"
                                (ngModelChange)="applyFilter($event, 'bom')"
                                [disabled]="!selectedDetailvalues.product">
                        </md-input-container>

                        <mat-autocomplete #bomAutoComplete="matAutocomplete"
                            [displayWith]="bomValueMapper">
                            <mat-option class="line-detail"
                                *ngFor="let item of filteredData.bom.list"
                                [value]="item"
                                title="{{item?.value}}">
                                {{item?.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="button-container">
        <button mat-button
            class="cancel-btn"
            type="button"
            (click)="close_dialogue()">{{'common.cancel' | translate}}
        </button>
        <button mat-flat-button
            color="primary"
            class="apply-btn"
            (click)="applyFilters()"
            [disabled]="!selectedVisualizationValues.line"
            [ngClass]="{'disabled-btn': !selectedVisualizationValues.line}"
            type="button">{{'common.apply' | translate}}
        </button>
    </div>
</div>